module.exports = __webpack_public_path__ + "img/lunchbox-2.e607c7b9.png";